import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
const PanelStickyFooter = ({ children, className, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    return (_jsx("footer", { className: buildClassName('left-0 right-0 max-h-16 shrink-0 border-b-0 border-l-0 border-r-0 border-t-[1px] border-solid border-black/20 bg-white', 'items-center px-8 py-2.5', className), ...dataAttributes, children: children }));
};
export default PanelStickyFooter;
//# sourceMappingURL=PanelStickyFooter.js.map